export const REQUEST_PORT_MESSAGE_TYPE = 'REQUEST_PORT';
export const RECEIVE_PORT_MESSAGE_TYPE = 'RECEIVE_PORT';
//# sourceMappingURL=const.js.map